import { BaseQuestionnaireRoute } from '../slice';

export type ProfitandLossStatementRoutes = BaseQuestionnaireRoute;

export const profitandLossStatementRoutes: { profitandLossStatement: ProfitandLossStatementRoutes } = {
    profitandLossStatement: {
    title: 'Profit and Loss Statement',
    path: 'profitandLossStatement',
    isValid: undefined,
  },
};
